import styled from "styled-components";
import { devices } from "../../Devices.js";
import { Input } from "../sharable/InputStyle.jsx";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 4.2rem;

  @media ${devices.mobileL} {
    padding: 1.2rem 1.2rem;
  }

  .print-icon-span-wrapper {
    @media ${devices.tablet} {
      display: none;
    }

    margin-right: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    transition: color 300ms ease-in-out;
    cursor: pointer;

    &:hover {
      color: #d97706;
    }

    span {
      font-size: 1.2rem;
    }
  }

  .print-icon {
    width: 2.5rem;
    height: 2.5rem;
  }

  button {
    height: 2.7rem;
  }

  @media ${devices.tablet} {
    .share-download-button-wrapper {
      display: none;
    }
  }
`;

export const Container = styled.div`
  max-height: calc(100vh) important;
  overflow-y: hidden;

  @media ${devices.tablet} {
  }
`;

export const Layout = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 35% 65%;
  grid-template-rows: min-content min-content 1fr;
  max-height: 100%;

  @media ${devices.laptop} {
    grid-template-columns: 100vw;
    grid-template-rows: min-content min-content;
  }
`;

export const EncarteNameBox = styled(Input)`
  width: 20rem;
  background-color: transparent;
  border: none;

  @media ${devices.tablet} {
    width: 10rem;
  }

  border: 1px solid rgba(1, 1, 1, 0.4);
`;

export const ExportButtonWrapper = styled.div`
  position: relative;
  display: none;
  z-index: 10;

  @media ${devices.tablet} {
    display: inline-block;
  }

  .tag-share-button-wrapper {
    position: relative;
  }
`;

export const ExportOtpions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  position: absolute;
  top: 110%;
  right: 0%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 10;
  min-width: 140px;
  padding: 0.5rem;
`;
